let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1lXo2")).then(() => parcelRequire('8gPdF'));